import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import bg from "./bg";
import en from "./en";

// Езикът е винаги български, освен ако потребителят изрично е избрал английски
// от превключвателя — изборът се пази в localStorage и се уважава при следващо
// влизане. Езикът на устройството/браузъра НЕ се гледа.
const STORAGE_KEY = "app_language";

i18n.use(initReactI18next).init({
  resources: {
    bg: { translation: bg },
    en: { translation: en },
  },
  lng: localStorage.getItem(STORAGE_KEY) === "en" ? "en" : "bg",
  fallbackLng: "bg",
  interpolation: {
    escapeValue: false,
  },
});

// Всяка смяна на езика (LanguageSwitcher, ProfileDropdown) се запомня.
i18n.on("languageChanged", (lng) => {
  localStorage.setItem(STORAGE_KEY, lng);
});

export default i18n;
